import { GET_USERS } from "../../actions/type";
export default function adminUsers(state = {}, action) {
    switch (action.type) {
        case GET_USERS:
            return action.payload;
        default:
            return state
    }
}